import PromoterEventLive from './PromoterEventLive';

export default PromoterEventLive;
